<div class="fq-card fuseqCard mt-3" [class.embedded]="embedded()">
  @if (!embedded()) {
    <div class="fq-card-header fuseqCardHeader">TIMELINE SEDE</div>
  }
  <div class="fq-card-body fuseqCardBody">

    <div class="px-4 pt-3">
      @if (!embedded()) {
        <div class="flex flex-wrap items-end gap-3">
          <div class="min-w-[320px] flex-1">
            <label class="mb-1 block text-sm font-medium text-fq-text-2" for="tl-site">Frazionario / sede</label>
            <p-select inputId="tl-site" [options]="sites()" optionLabel="label" optionValue="value"
              [filter]="true" filterBy="label" [virtualScroll]="true" [virtualScrollItemSize]="36"
              [ngModel]="fraz()" (ngModelChange)="onSiteChange($event)"
              placeholder="Cerca per frazionario o denominazione…" appendTo="body" class="w-full"></p-select>
          </div>
          <button type="button" class="fq-btn fq-btn-primary" [disabled]="loading() || !fraz()" (click)="refresh()">
            <fa-icon [icon]="['fas', 'refresh']" [animation]="loading() ? 'spin' : null" aria-hidden="true"></fa-icon>
            Aggiorna
          </button>
        </div>

        @if (site(); as s) {
          <div class="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 rounded-lg border border-fq-border-soft bg-fq-surface-muted px-3 py-2 text-sm text-fq-text-2">
            <span class="fq-badge fq-badge-primary">{{ s.fraz }}</span>
            @if (s.denominazione) { <span class="font-semibold">{{ s.denominazione }}</span> }
            @if (s.comune) { <span class="text-fq-text-muted">{{ s.comune }}@if (s.sigla_provincia) { ({{ s.sigla_provincia }}) }</span> }
            @if (s.filiale) { <span class="text-fq-text-muted">· Filiale {{ s.filiale }}</span> }
            @if (s.polo) { <span class="text-fq-text-muted">· Polo {{ s.polo }}</span> }
            @if (s.id_anagrafica) { <span class="text-fq-text-muted">· ID {{ s.id_anagrafica }}</span> }
          </div>
        }
      }

      <div class="flex flex-wrap items-center gap-2" [class.mt-3]="!embedded()">
        <button type="button" class="fq-btn" [ngClass]="mode() === 'all' ? 'fq-btn-primary' : 'fq-btn-outline-primary'" (click)="setMode('all')">Tutto</button>
        <button type="button" class="fq-btn" [ngClass]="mode() === 'operational' ? 'fq-btn-primary' : 'fq-btn-outline-primary'" (click)="setMode('operational')">Solo operativo</button>
        <p-select [options]="areas" optionLabel="label" optionValue="value" [ngModel]="area()" (ngModelChange)="setArea($event)"
          appendTo="body" class="w-56"></p-select>
        @if (rtuFilter()) {
          <label class="flex cursor-pointer items-center gap-2 text-xs font-medium text-fq-text-2">
            <p-checkbox [binary]="true" [ngModel]="showRtu()" (ngModelChange)="setShowRtu($event)"
              inputId="tl-show-rtu"></p-checkbox>
            <span>Mostra eventi RTU</span>
            @if (!showRtu() && rtuCount() > 0) {
              <span class="rounded-full bg-fq-surface-muted px-1.5 py-0.5 text-[10px] font-semibold text-fq-text-muted">
                {{ rtuCount() }} nascosti
              </span>
            }
          </label>
        }
        @if (embedded()) {
          <button type="button" class="fq-btn fq-btn-outline-primary fq-btn-sm" [disabled]="loading()" (click)="refresh()">
            <fa-icon [icon]="['fas', 'rotate']" [animation]="loading() ? 'spin' : null" aria-hidden="true"></fa-icon>
            Aggiorna
          </button>
        }
        <span class="ml-auto text-xs font-semibold text-fq-text-muted">{{ filtered().length }} eventi</span>
      </div>
    </div>

    @if (warnings().length > 0) {
      <div class="mx-4 my-2 rounded-lg border border-fq-warning/30 bg-fq-warning/10 px-3 py-2 text-xs text-fq-warning">
        <div class="flex items-start gap-2">
          <fa-icon [icon]="['fas', 'triangle-exclamation']" class="mt-0.5" aria-hidden="true"></fa-icon>
          <div class="min-w-0 flex-1">
            <div class="leading-snug">
              <span class="font-semibold">Fonti non disponibili ({{ warnings().length }}):</span>
              {{ warningLabels() }}. La timeline mostra le altre.
            </div>
            @if (warningDetails(); as details) {
              <ul class="mt-1 grid gap-0.5">
                @for (detail of details; track $index) {
                  <li class="leading-snug">
                    <span class="font-semibold">{{ detail.label }}</span>
                    <span> — {{ detail.message }}</span>
                  </li>
                }
              </ul>
            }
          </div>
        </div>
      </div>
    }

    @if (loading()) {
      <div class="px-4 py-10 text-center text-sm text-fq-text-muted">
        <fa-icon [icon]="['fas', 'spinner']" animation="spin" class="mr-2" aria-hidden="true"></fa-icon>
        Caricamento timeline…
      </div>
    } @else if (error()) {
      <div class="mx-4 my-3 rounded-lg border border-fq-danger/30 bg-fq-danger/10 px-3 py-2 text-sm text-fq-danger">{{ error() }}</div>
    } @else if (!fraz()) {
      <div class="px-4 py-10 text-center text-sm text-fq-text-muted">Seleziona una sede per vedere la timeline.</div>
    } @else if (filtered().length === 0) {
      <div class="px-4 py-10 text-center text-sm text-fq-text-muted">
        <fa-icon [icon]="['fas', 'timeline']" class="mb-2 block text-lg opacity-60" aria-hidden="true"></fa-icon>
        Nessun evento per i filtri selezionati.
        @if (rtuFilter() && !showRtu() && rtuCount() > 0) {
          <div class="mt-1 text-xs">
            {{ rtuCount() }} eventi RTU nascosti: attiva «Mostra eventi RTU».
          </div>
        }
      </div>
    } @else {

      <div class="px-4 pb-2">
        @for (group of grouped(); track group.key) {
          <div class="timeline-day">{{ group.label }}</div>
          @for (event of group.events; track trackEvent($index, event)) {
            <div class="timeline-item">
              <div class="timeline-marker" [ngClass]="statusClass(event.status)">
                <i [class]="areaIcon(event.area)" aria-hidden="true"></i>
              </div>
              <div class="timeline-card">
                <div class="flex items-start justify-between gap-3">
                  <div class="min-w-0">
                    <div class="text-sm font-bold leading-snug text-fq-text">{{ cleanText(event.title) }}</div>
                    @if (cleanText(event.description)) {
                      <div class="mt-0.5 whitespace-pre-wrap text-xs leading-snug text-fq-text-muted">{{ cleanText(event.description) }}</div>
                    }
                  </div>
                  <div class="flex shrink-0 items-start gap-2">
                    <span class="pt-0.5 text-xs font-semibold text-fq-text-muted">{{ formatTime(event.date) }}</span>
                    <button type="button" class="tl-open" (click)="openDetail(event)"
                      title="Dettaglio evento" aria-label="Dettaglio evento">
                      <fa-icon [icon]="['fas', 'circle-info']" aria-hidden="true"></fa-icon>
                    </button>
                    @if (event.link) {
                      <a [href]="event.link" class="tl-open" target="_blank" rel="noopener noreferrer"
                        title="Apri nella pagina sorgente" aria-label="Apri nella pagina sorgente">
                        <fa-icon [icon]="['fas', 'external-link']" aria-hidden="true"></fa-icon>
                      </a>
                    }
                    @if (!embedded() && siteFraz(); as siteFraz) {
                      <a [routerLink]="['/awp/sites', siteFraz]" class="tl-open"
                        title="Vai alla scheda sede" aria-label="Vai alla scheda sede">
                        <fa-icon [icon]="['fas', 'location-dot']" aria-hidden="true"></fa-icon>
                      </a>
                    }
                  </div>
                </div>
                <div class="mt-2 flex flex-wrap items-center gap-1.5">
                  <span class="tl-chip">{{ areaLabel(event.area) }}</span>
                  <span class="tl-chip" [ngClass]="statusClass(event.status)">{{ statusLabel(event.status) }}</span>
                  @if (event.meta?.username) {
                    <span class="tl-chip"><fa-icon [icon]="['fas', 'user']" aria-hidden="true"></fa-icon> {{ event.meta.username }}</span>
                  }
                </div>
              </div>
            </div>
          }
        }
      </div>

      @if (hasMore()) {
        <div class="pb-4 text-center">
          <button type="button" class="fq-btn fq-btn-outline-primary" (click)="loadMore()">Carica altri</button>
        </div>
      }
    }

  </div>
</div>

<p-dialog [visible]="detailVisible()" (visibleChange)="detailVisible.set($event)"
  [header]="cleanText(detailEvent()?.title) || 'Dettaglio evento'" [modal]="true" [draggable]="false" [resizable]="false"
  [style]="{ width: 'min(820px, 95vw)' }" [contentStyle]="{ 'max-height': '72vh', 'overflow-y': 'auto' }"
  [baseZIndex]="2300">
  @if (detailEvent(); as e) {
    <div class="grid gap-3">
      <div class="flex flex-wrap items-center gap-2">
        <span class="tl-chip">{{ areaLabel(e.area) }}</span>
        <span class="tl-chip" [ngClass]="statusClass(e.status)">{{ statusLabel(e.status) }}</span>
        <span class="text-xs text-fq-text-muted">{{ formatDateTime(e.date) }}</span>
      </div>

      @if (cleanText(e.description)) {
        <div class="whitespace-pre-wrap text-sm text-fq-text-2">{{ cleanText(e.description) }}</div>
      }

      <div class="grid gap-1 text-xs text-fq-text-2">
        <div><span class="font-semibold text-fq-text-muted">Fonte:</span> {{ e.source }}</div>
        <div><span class="font-semibold text-fq-text-muted">Area:</span> {{ areaLabel(e.area) }}</div>
        <div><span class="font-semibold text-fq-text-muted">Tipo:</span> {{ e.type || '—' }}</div>
        <div><span class="font-semibold text-fq-text-muted">Evento:</span> <span class="font-mono">{{ e.id }}</span></div>
      </div>

      @if (detailMetaFields().length > 0) {
        <div class="rounded-lg border border-fq-border-soft bg-fq-surface-subtle p-3">
          <div class="mb-1 text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">Contesto</div>
          <div class="grid gap-1 text-xs">
            @for (field of detailMetaFields(); track field.key) {
              <div class="grid grid-cols-[minmax(7rem,auto)_1fr] gap-2">
                <span class="text-fq-text-muted">{{ field.label }}</span>
                <span class="whitespace-pre-wrap break-words text-fq-text-2">{{ field.value }}</span>
              </div>
            }
          </div>
        </div>
      }

      @if (detailLoading()) {
        <div class="py-2 text-sm text-fq-text-muted">
          <fa-icon [icon]="['fas', 'spinner']" animation="spin" class="mr-2" aria-hidden="true"></fa-icon>
          Caricamento dettaglio…
        </div>
      } @else if (detailError()) {
        <div class="rounded-lg border border-fq-warning/30 bg-fq-warning/10 px-3 py-2 text-xs text-fq-warning">{{ detailError() }}</div>
      } @else if (detailFields().length > 0) {
        <div class="rounded-lg border border-fq-border-soft bg-fq-surface-subtle p-3">
          <div class="mb-1 flex flex-wrap items-center gap-2">
            <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">Dettaglio</span>
            @if (detailTable()) { <span class="font-mono text-[10px] text-fq-text-muted">{{ detailTable() }}</span> }
          </div>
          <div class="grid gap-1 text-xs">
            @for (field of detailFields(); track field.key) {
              <div class="grid grid-cols-[minmax(7rem,auto)_1fr] gap-2 border-b border-fq-border-faint py-1 last:border-b-0">
                <span class="text-fq-text-muted">{{ field.label }}</span>
                <span class="whitespace-pre-wrap break-words text-fq-text-2">{{ field.value }}</span>
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="text-xs text-fq-text-muted">Nessun dettaglio aggiuntivo disponibile per questo evento.</div>
      }

      @if (e.link) {
        <a [href]="e.link" target="_blank" rel="noopener noreferrer" class="fq-btn fq-btn-outline-primary self-start">
          <fa-icon [icon]="['fas', 'external-link']" aria-hidden="true"></fa-icon>
          Apri nella pagina sorgente
        </a>
      }
    </div>
  }
  <ng-template pTemplate="footer">
    <button type="button" class="fq-btn fq-btn-primary" (click)="closeDetail()">Chiudi</button>
  </ng-template>
</p-dialog>
